import { render, staticRenderFns } from "./DocumentationSidebar.vue?vue&type=template&id=ea91aae4&"
import script from "./DocumentationSidebar.vue?vue&type=script&lang=js&"
export * from "./DocumentationSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports